import { FC } from 'react'

import { colorVariant } from '@trustycars/genie-ui/style/atoms'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import { Props } from './types'

const Motto: FC<Props> = ({ ...props }) => (
  <svg
    fill="none"
    width={104}
    height={32}
    viewBox="0 0 104 32"
    {...propsWithClassNames(props, colorVariant['text.default'])}
  >
    <g clipPath="url(#clip0_66_1614)">
      <path
        d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z"
        fill="white"
      />
      <mask
        height={32}
        id="mask0_66_1614"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width={32}
        x={0}
        y={0}
      >
        <path
          d="M23.4733 12.9986C23.4128 13.16 23.287 13.2909 23.1284 13.358L21.468 14.0604C21.1648 14.1885 20.8121 14.0613 20.6652 13.7712C19.7769 12.017 17.9317 10.9864 15.9654 11.1467C13.5374 11.3437 11.5958 13.4089 11.5453 15.8486C11.5183 17.1538 12.0074 18.3871 12.9223 19.3211C13.8377 20.2555 15.0601 20.7702 16.3642 20.7702C18.0493 20.7702 19.5832 19.9144 20.4676 18.481C20.6357 18.2081 20.9881 18.1111 21.2694 18.2599L22.8947 19.1189C23.0431 19.1972 23.1546 19.3351 23.2001 19.4969C23.2453 19.6579 23.2225 19.8322 23.1374 19.9753C21.725 22.3518 19.1295 23.8279 16.3642 23.8279C14.256 23.8279 12.2737 23.0027 10.7827 21.5043C9.2919 20.0062 8.4765 18.0197 8.48677 15.9111C8.50668 11.8236 11.7109 8.38968 15.7816 8.09398C19.0256 7.85697 22.0347 9.59026 23.4509 12.5063C23.5263 12.6616 23.5343 12.8364 23.4733 12.9986ZM29.1127 10.5693C28.3476 8.7243 28.7042 6.07669 27.3138 4.68624C25.9236 3.296 23.276 3.65247 21.431 2.88735C19.6512 2.14948 18.0466 0 16 0C13.9534 0 12.349 2.14948 10.5692 2.88735C8.72445 3.65247 6.07665 3.296 4.68642 4.68624C3.29598 6.07669 3.65265 8.7243 2.88775 10.5693C2.14968 12.3489 0 13.9535 0 16.0001C0 18.0467 2.14968 19.6513 2.88754 21.4309C3.65265 23.2759 3.29598 25.9235 4.68642 27.3138C6.07665 28.7042 8.72445 28.3477 10.5692 29.1126C12.349 29.8507 13.9534 32 16 32C18.0466 32 19.6512 29.8507 21.431 29.1126C23.276 28.3477 25.9234 28.7042 27.3138 27.314C28.704 25.9235 28.3476 23.2759 29.1127 21.4309C29.8505 19.6513 32 18.0467 32 16.0001C32 13.9535 29.8505 12.3489 29.1127 10.5693Z"
          fill="#FBFBFB"
          clipRule="evenodd"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_66_1614)">
        <mask
          height={32}
          id="mask1_66_1614"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width={32}
          x={0}
          y={0}
        >
          <path d="M32 0H0V32H32V0Z" fill="white" />
        </mask>
        <g mask="url(#mask1_66_1614)">
          <path d="M31.9995 0H-0.000518799V32H31.9995V0Z" fill="white" />
          <g filter="url(#filter0_f_66_1614)">
            <path
              d="M47.3516 20.7409C43.1274 11.7614 34.2254 7.05877 27.4683 10.2374C20.7113 13.416 18.6579 23.2722 22.882 32.2518C27.1061 41.2314 36.0082 45.934 42.7653 42.7553C49.5223 39.5767 51.5757 29.7205 47.3516 20.7409Z"
              fill="#020F2D"
            />
          </g>
          <g filter="url(#filter1_f_66_1614)">
            <path
              d="M11.4716 18.2151C3.53454 12.2586 -5.74086 11.2158 -9.2456 15.8859C-12.7503 20.556 -9.15728 29.1705 -1.22025 35.127C6.71678 41.0835 15.9922 42.1263 19.4969 37.4562C23.0017 32.7861 19.4086 24.1716 11.4716 18.2151Z"
              fill="#002E5D"
            />
          </g>
          <g filter="url(#filter2_f_66_1614)">
            <path
              d="M25.8748 11.9548C27.5993 6.78916 21.2176 0.0044267 11.6208 -3.19936C2.02407 -6.40315 -7.15362 -4.81278 -8.87811 0.352831C-10.6026 5.51844 -4.22086 12.3032 5.3759 15.507C14.9727 18.7108 24.1503 17.1204 25.8748 11.9548Z"
              fill="#021222"
            />
          </g>
          <g filter="url(#filter3_f_66_1614)">
            <path
              d="M50.7165 4.26068C49.8289 14.8139 40.5544 22.6495 30.0012 21.7619C19.448 20.8744 11.6124 11.5999 12.4999 1.04665C13.3874 -9.50656 22.662 -17.3421 33.2152 -16.4546C43.7684 -15.5671 51.604 -6.29253 50.7165 4.26068Z"
              fill="#002E5D"
            />
          </g>
          <g filter="url(#filter4_f_66_1614)">
            <path
              d="M2.49946 18C-4.47763 14.0661 -8.34798 10.3305 -9.17182 9.34381C-8.3997 7.72094 7.15518 10.8214 10.4995 11.5006C23.2878 17.5849 19.7575 18.3556 18.9853 19.9785C18.2132 21.6014 9.83156 21.2738 2.49946 18Z"
              fill="#002E5D"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      d="M54.6328 13.9595C57.1964 13.9595 59.2754 16.0371 59.2754 18.6021C59.2752 21.1655 57.1963 23.2437 54.6328 23.2437C52.0694 23.2436 49.9905 21.1654 49.9902 18.6021C49.9902 16.0385 52.0693 13.9595 54.6328 13.9595ZM87.3389 16.311C87.8393 16.311 88.2763 16.3967 88.6494 16.5679C89.0248 16.7391 89.3168 16.9776 89.5254 17.2827C89.734 17.5879 89.842 17.9415 89.8486 18.3433H88.4814C88.4551 18.0777 88.3424 17.8712 88.1426 17.7241C87.9428 17.577 87.6716 17.5034 87.3291 17.5034C87.0963 17.5034 86.8996 17.5362 86.7393 17.6021C86.5793 17.6656 86.4567 17.7547 86.3711 17.8687C86.2877 17.9828 86.2452 18.1126 86.2451 18.2573C86.2407 18.378 86.2664 18.4837 86.3213 18.5737C86.3784 18.6637 86.4559 18.7423 86.5547 18.8081C86.6535 18.8718 86.7679 18.9278 86.8975 18.9761C87.027 19.0222 87.1654 19.0613 87.3125 19.0942L87.9189 19.2388C88.2129 19.3046 88.4827 19.3928 88.7285 19.5024C88.9744 19.6122 89.1881 19.7474 89.3682 19.9077C89.5481 20.0679 89.6874 20.2569 89.7861 20.4741C89.8871 20.6915 89.9382 20.9411 89.9404 21.2222C89.9382 21.6347 89.8334 21.9925 89.625 22.2954C89.4186 22.5962 89.1193 22.8307 88.7285 22.9976C88.34 23.1621 87.871 23.2437 87.3223 23.2437C86.7778 23.2436 86.3034 23.1605 85.8994 22.9937C85.4978 22.8268 85.1841 22.5795 84.958 22.2524C84.7341 21.9231 84.6164 21.516 84.6055 21.0308H85.9854C86.0007 21.2569 86.0656 21.4457 86.1797 21.5972C86.296 21.7464 86.4505 21.8602 86.6436 21.937C86.8389 22.0116 87.0599 22.0483 87.3057 22.0483C87.5472 22.0483 87.7577 22.0131 87.9355 21.9429C88.1153 21.8726 88.2548 21.7749 88.3535 21.6499C88.4522 21.5247 88.502 21.3806 88.502 21.2183C88.5019 21.0669 88.4562 20.9395 88.3662 20.8364C88.2784 20.7333 88.1486 20.6451 87.9775 20.5728C87.8086 20.5004 87.6011 20.4347 87.3555 20.3755L86.6211 20.1909C86.0524 20.0526 85.6028 19.8367 85.2734 19.5425C84.9441 19.2482 84.781 18.8514 84.7832 18.353C84.781 17.9447 84.8898 17.5879 85.1094 17.2827C85.3311 16.9776 85.6351 16.7391 86.0215 16.5679C86.4079 16.3966 86.8471 16.311 87.3389 16.311ZM93.4473 16.311C93.9477 16.3111 94.3846 16.3966 94.7578 16.5679C95.1332 16.7391 95.425 16.9776 95.6338 17.2827C95.8423 17.5879 95.9497 17.9415 95.9561 18.3433H94.5898C94.5635 18.0777 94.4506 17.8712 94.251 17.7241C94.0513 17.5771 93.7799 17.5035 93.4375 17.5034C93.2049 17.5034 93.0079 17.5362 92.8477 17.6021C92.6875 17.6657 92.5641 17.7546 92.4785 17.8687C92.3952 17.9828 92.3536 18.1126 92.3535 18.2573C92.3491 18.3781 92.3748 18.4837 92.4297 18.5737C92.4868 18.6637 92.5643 18.7423 92.6631 18.8081C92.7619 18.8718 92.8764 18.9278 93.0059 18.9761C93.1354 19.0221 93.2739 19.0613 93.4209 19.0942L94.0264 19.2388C94.3205 19.3046 94.591 19.3927 94.8369 19.5024C95.0828 19.6122 95.2955 19.7475 95.4756 19.9077C95.6558 20.068 95.7957 20.2568 95.8945 20.4741C95.9956 20.6915 96.0465 20.9411 96.0488 21.2222C96.0465 21.6347 95.9418 21.9925 95.7334 22.2954C95.5268 22.5962 95.2278 22.8307 94.8369 22.9976C94.4483 23.1622 93.9795 23.2436 93.4307 23.2437C92.8862 23.2437 92.4118 23.1606 92.0078 22.9937C91.606 22.8268 91.2916 22.5796 91.0654 22.2524C90.8417 21.9231 90.7239 21.5158 90.7129 21.0308H92.0938C92.1091 21.2569 92.1739 21.4457 92.2881 21.5972C92.4044 21.7465 92.5587 21.8602 92.752 21.937C92.9473 22.0117 93.1682 22.0483 93.4141 22.0483C93.6556 22.0483 93.8651 22.0131 94.043 21.9429C94.2229 21.8726 94.3621 21.775 94.4609 21.6499C94.5598 21.5247 94.6094 21.3807 94.6094 21.2183C94.6093 21.0669 94.5646 20.9395 94.4746 20.8364C94.3868 20.7333 94.2571 20.6452 94.0859 20.5728C93.9169 20.5004 93.7096 20.4347 93.4639 20.3755L92.7295 20.1909C92.1608 20.0526 91.7112 19.8367 91.3818 19.5425C91.0525 19.2482 90.8894 18.8514 90.8916 18.353C90.8894 17.9448 90.9974 17.5879 91.2168 17.2827C91.4386 16.9775 91.7435 16.7391 92.1299 16.5679C92.5162 16.3967 92.9556 16.311 93.4473 16.311ZM74.9307 11.2378C78.2456 11.2378 80.9336 13.9259 80.9336 17.2407C80.9334 20.5555 78.2455 23.2427 74.9307 23.2427C71.616 23.2426 68.9289 20.5555 68.9287 17.2407C68.9287 13.9259 71.6158 11.2378 74.9307 11.2378ZM99.9795 16.313C100.574 16.313 101.11 16.449 101.587 16.7212C102.065 16.9911 102.443 17.3842 102.72 17.8999C102.999 18.4159 103.139 19.0423 103.139 19.7778C103.139 20.5134 102.999 21.1388 102.72 21.6548C102.443 22.1708 102.065 22.5651 101.587 22.8374C101.11 23.1074 100.574 23.2427 99.9795 23.2427C99.38 23.2426 98.8421 23.1066 98.3662 22.8345C97.8896 22.5622 97.5131 22.1678 97.2363 21.6519C96.9596 21.1359 96.8213 20.5112 96.8213 19.7778C96.8213 19.0423 96.9596 18.4159 97.2363 17.8999C97.513 17.3841 97.8897 16.9912 98.3662 16.7212C98.8422 16.449 99.38 16.3131 99.9795 16.313ZM48.6865 23.1069H46.0156V16.2144L43.3438 19.9263L40.6729 16.5845V23.1069H38V13.0679L40.8223 12.52L43.3438 15.7915L45.8779 11.5366L48.6865 10.9917V23.1069ZM80.7461 7.47705L67.625 10.0249V23.1069H64.9521V10.5435L63.2764 10.8735V23.1069H60.6045V11.3911L50.0225 13.4507V10.729L80.7461 4.75635V7.47705ZM99.9795 17.5747C99.6348 17.5748 99.3341 17.6587 99.0771 17.8276C98.8201 17.9967 98.6202 18.2456 98.4775 18.5728C98.3373 18.8998 98.2676 19.3016 98.2676 19.7778C98.2676 20.2541 98.3372 20.6558 98.4775 20.9829C98.6202 21.3099 98.8203 21.558 99.0771 21.7271C99.3341 21.8961 99.6348 21.9809 99.9795 21.981C100.324 21.981 100.626 21.8962 100.883 21.7271C101.14 21.558 101.338 21.3099 101.479 20.9829C101.621 20.6558 101.692 20.2542 101.692 19.7778C101.692 19.3015 101.621 18.8998 101.479 18.5728C101.338 18.2457 101.14 17.9967 100.883 17.8276C100.626 17.6586 100.324 17.5747 99.9795 17.5747ZM54.6328 16.5884C53.5207 16.5884 52.6201 17.4899 52.6201 18.6021C52.6204 19.714 53.5209 20.6147 54.6328 20.6147C55.7435 20.6147 56.6443 19.714 56.6445 18.6021C56.6445 17.4899 55.7436 16.5884 54.6328 16.5884ZM74.9307 14.3433C73.3298 14.3433 72.0332 15.6412 72.0332 17.2407C72.0334 18.8415 73.3313 20.1381 74.9307 20.1382C76.5302 20.1382 77.8266 18.8415 77.8281 17.2407C77.8281 15.6399 76.5303 14.3433 74.9307 14.3433Z"
      fill="currentColor"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="74.5046"
        id="filter0_f_66_1614"
        width="68.8614"
        x="0.686111"
        y="-10.7559"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_66_1614"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="67.4109"
        id="filter1_f_66_1614"
        width="71.4279"
        x="-30.5883"
        y="-7.03436"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_66_1614"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="62.0151"
        id="filter2_f_66_1614"
        width="75.3156"
        x="-29.1594"
        y="-24.8538"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_66_1614"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="78.3536"
        id="filter3_f_66_1614"
        width="78.3537"
        x="-7.56865"
        y="-36.5231"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_66_1614"
          stdDeviation={10}
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="52.0493"
        id="filter4_f_66_1614"
        width="69.1876"
        x="-29.1718"
        y="-11.1204"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_66_1614"
          stdDeviation={10}
        />
      </filter>
      <clipPath id="clip0_66_1614">
        <rect fill="white" height={32} width={32} />
      </clipPath>
    </defs>
  </svg>
)

export default Motto
